<template>
  <div class="inner-content">
    <h2 style="margin-bottom: 20px;">確認コード入力</h2>
    <Spinner :isLoading="isLoading" />
    <div>
      <form @submit.prevent="onConfirmChangeEmail()" method="post">
        <p class="mb10" style="font-size: 14px;">ご本人様確認のため確認コードを送信しました。送られている確認コードを入力してください。</p>
        <p class="mb10" style="font-size: 14px;">確認コードを入力してください</p>
        <input
          type="text"
          class="change-email mb10"
          v-model="confirmChangeEmail.code"
          :class="[$v.confirmChangeEmail.code.$error ? 'input-error' : '']"
          inputmode="numeric"
          oninput="this.value = this.value.replace(/[^0-9]/g, '');"
          maxlength="6"
        />
        <div v-if="confirmChangeEmailSubmitted && $v.confirmChangeEmail.code.$error">
          <p class="error-txt mb20" v-if="!$v.confirmChangeEmail.code.required">{{ $t('please_enter_the_verification_code') }}</p>
          <p class="error-txt mb20" v-else>{{ $t('the_verification_code_is_different') }}</p>
        </div>
        <div class="mb10">
          <p
            class="error-txt mb10"
            v-if="confirmChangeEmailSubmitted && errConfirmChangeEmail"
          >
            {{ errConfirmChangeEmail }}
          </p>
        </div>
        <div class="mb20">
          <a href="javascript:;" v-on:click="resendConfirmCode()" style="color: #333333;"><p>確認コードを再送信する</p></a>
        </div>
        <button class="btn-base mb20" type="submit" style="border: #ffa300">
          <a style="font-weight: 600;"><p>送信</p></a>
        </button>
      </form>
    </div>
    <div id="modal">
      <b-modal
        id="modal-notice"
        centered
        :hide-header="true"
        :hide-footer="true"
        class="modal-content"
      >
        <div class="modal-inner">
          <p class="modal-ttl" v-if="!errConfirmChangeEmail">
            メールアドレスを変更しました。
          </p>
          <p class="modal-txt-error mb50">
            ログインページに戻り、新しいメールアドレスでログインしてください。
          </p>
          <div class="btn-base pos-center">
            <a href="javascript:;" class="modal-close" @click="handleModal">
              <p>{{ $t("ok") }}</p>
            </a>
          </div>
        </div>
      </b-modal>
    </div>
    <div id="modal">
      <b-modal
        id="modal-notice-resend"
        centered
        :hide-header="true"
        :hide-footer="true"
        class="modal-content"
      >
        <div class="modal-inner">
          <p class="modal-ttl" v-if="resendConfirmCodeErr && confirmChangeEmailSubmitted">
            認証コードを送信しました
          </p>
          <p class="modal-txt-error mb50">
            こちらの画面を閉じて送られている認証コードを<br/>入力してください。
          </p>
          <div class="btn-base pos-center">
            <a href="javascript:;" class="modal-close" @click="closeModal">
              <p>{{ $t("ok") }}</p>
            </a>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>
  
<script>
import { required, numeric } from "vuelidate/lib/validators";
import { mapState } from "vuex";
import { BModal, VBModal, BButton } from "bootstrap-vue";
import Spinner from "@/js/components/Spinner";

export default {
  data() {
    return {
      confirmChangeEmail: {
        code: "",
      },
      confirmChangeEmailSubmitted: false,
      isLoading: false,
    };
  },
  validations: {
    confirmChangeEmail: {
      code: { required, numeric },
    },
  },
  components: {
    Spinner,
  },
  computed: {
    ...mapState({
      errConfirmChangeEmail: (state) => state.auth.errConfirmChangeEmail,
      resendConfirmCodeErr: state => state.auth.resendConfirmCodeErr,
      access_token: (state) => state.auth.access_token,
    }),
  },
  mounted() {
    this.screenTracking(this.$t("those_who_have_forgotten_PW"));
  },
  methods: {
    async onConfirmChangeEmail() {
      this.confirmChangeEmailSubmitted = true;
      this.$v.confirmChangeEmail.$touch();
      if (this.$v.confirmChangeEmail.$error) return;
      else {
        this.isLoading = true
        const params = {
          code: this.confirmChangeEmail.code,
          email: this.$store.state.auth.emailChange.email,
          access_token: this.$store.state.auth.emailChange.access_token
        }
        await this.$store.dispatch("auth/confirmChangeEmail", params);
        if (!this.errConfirmChangeEmail) {
          this.$store.dispatch('otp/initLogout')
          this.$store.dispatch('auth/logout')
          window.localStorage.setItem('isLogout', true)
          this.$bvModal.show("modal-notice");
        }
      }
      this.isLoading = false
    },
    handleModal() {
      this.$router.push('/login')
    },
    async resendConfirmCode() {
      let params = {
        email: this.$store.state.auth.emailChange.email,
        access_token: this.$store.state.auth.emailChange.access_token
      };
      this.confirmChangeEmailSubmitted = true
      this.isLoading = true;
      await this.$store.dispatch("auth/resendConfirmationCode", params);
      this.isLoading = false;
      if (this.resendConfirmCodeErr) {
        this.$bvModal.show("modal-notice-resend")
      }
    },
    closeModal() {
      this.$bvModal.hide("modal-notice-resend");
    }
  },
  watch : {
    "confirmChangeEmail.code": function () {
      if (!this.confirmChangeEmail.code) {
        this.$store.dispatch("auth/clearErrMessage");
      }
    },
  },
  directives: { BModal, VBModal, BButton }
};
</script>
<style scoped>
.change-email {
  box-sizing: border-box;
  width: 400px;
  padding: 6px;
  border: 1px solid #ff9fae;
}
.error-txt {
  color: #ff0000;
  font-size: 0.8rem;
}
</style>